import rest from '../rest/rest-service';
import * as _ from "lodash";

export const SourceService = {
    async query() {
        return rest.get(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings`); 
    },

    async get(source, filterCriteria) {
        if(filterCriteria){
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${source}`,filterCriteria);      
        }
        return rest.get(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${source}`);
    },

    async getSettingByKey(setting, returnActive) {
        let activePath = "";
        if (returnActive) {
            activePath = "/true";
        }
        return rest.get(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}${activePath}`);      
    },

    async add(setting) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}`,setting);
    },

    async save(setting) {
        return rest.put(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}`,setting);        
    },

    async requestApproval(setting) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}/request-approval`,setting);
    },

    async approve(setting) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}/approve`,setting);
    },

    async deny(setting) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}/deny`,setting);        
    },

    async publish(setting) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}/publish`,setting);
    },

    async cancelUpdate(setting) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-settings/${setting.source_name}/${setting.setting_type}/${setting.setting_key_id}/cancel-update`,setting);
    }
};



// WEBPACK FOOTER //
// ./src/services/pa/source.service.js